export default {
    'general': {
        'versioning': 'Ustvarjanje verzij',
        'dashboard': 'Nadzorna plošča',
        'email': 'E-pošta',
        'username': 'Uporabniško ime',
        'name': 'Ime',
        'password': 'Geslo',
        'actions': 'Dejanja',
        'login': 'Prijava',
        'logout': 'Odjava',
        'no_results': 'Ni rezultatov',
        'success': 'Uspeh',
        'warning': 'Opozorilo',
        'remember_me': 'Zapomni si me',
        'error': 'Napaka',
        'edit': 'Uredi',
        'details': 'Podrobnosti',
        'add': 'Dodaj',
        'delete': 'Izbriši',
        'yes': 'Da',
        'no': 'Ne',
        'cancel': 'Prekliči',
        'back': 'Nazaj',
        'image': 'Slika',
        'filters': 'Filtri',
        'remove_filters': 'Odstrani filtre',
        'default': 'Privzeto',
        'save': 'Shrani',
        'key': 'Ključ',
        'distribution_zone': 'Distribucijsko območje',
        'preview': 'Predogled',
        'icon': 'Ikona',
        'last_edited': 'Nazadnje urejeno',
        'unknown': 'Neznano',
        'latest_version': 'Najnovejša verzija',
        'change': 'Spremeni',
        'unlimited': 'Neomejeno',
        'from': 'Od',
        'to': 'Do',
        'date': 'Datum',
        'custom': 'Po meri',
        'country': 'Država',
        'total': 'Skupaj',
        'basic_data': 'Osnovni podatki',
        'show_more': 'Prikaži več',
        'profile': 'Profil',
        'export_data': 'Izvozi podatke',
        'approve': 'Potrdi',
        'reject': 'Zavrni'
    },
    'errors': {
        'generic_error': 'Prišlo je do napake',
        'login': 'Prišlo je do napake pri prijavi',
        'logout': 'Prišlo je do napake pri odjavi',
        'incorrect_password': 'Staro geslo ni pravilno',
        'invalid_data': 'Prejeti neveljavni podatki',
        'not_found': 'Podatki niso najdeni',
        'user_exist': 'Uporabnik s tem uporabniškim imenom že obstaja',
        'load_data': 'Prišlo je do napake pri nalaganju podatkov',
        'on_upload_image': 'Prišlo je do napake pri nalaganju slik',
        'on_upload_file': 'Prišlo je do napake pri nalaganju datotek',
        'on_publish': 'Prišlo je do napake med objavljanjem',
        'on_approve': 'Prišlo je do napake med potrjevanjem',
        'on_download': 'Prišlo je do napake med prenosom datoteke',
        'on_add': 'Prišlo je do napake pri dodajanju',
        'on_edit': 'Prišlo je do napake pri urejanju',
        'on_delete': 'Prišlo je do napake pri brisanju',
        'on_sort': 'Prišlo je do napake pri razvrščanju',
        'unauthorized': 'Nepooblaščeno',
        'user_does_not_exist': 'Uporabnik ne obstaja',
        'username_exists': 'To uporabniško ime že obstaja. Prosimo, uporabite drugo.',
        'failed_to_insert': 'Vstavljanje ni uspelo',
        'file_to_big': 'Datoteka je prevelika',
        'missing_roles': 'Manjkajoče vloge',
        'no_roles_selected': 'Uporabnik mora imeti izbrano vsaj eno vlogo',
        'fetching_data': 'Napaka pri pridobivanju podatkov',
        'deleting_default_data': 'Napaka pri brisanju privzetih podatkov',
        'data_already_exists': 'Podatki že obstajajo',
        'unable_to_retrieve_extension': 'Razširitve ni mogoče pridobiti',
        'no_access': 'Ni dostopa',
        'equipment_not_purchased': 'Ni kupljena vsa oprema',
        'role_exists': 'Vloga obstaja',
        'role_does_not_exist': 'Vloga ne obstaja',
        'time_parser': {
            'invalid_character_error': 'Dovoljene so samo številke in {0} enote.',
            'number': 'številka',
            'unit': 'enota',
            'invalid_format_error': 'Enote morajo biti v obliki',
            'duplicated_unit_error': 'Enota {0} je podvojena.',
            'example': '(primer: 3d12h)'
        },
        'max_queue_time': 'Prekoračen je največji čas za čakalno vrsto. Prosimo, uporabite krajše trajanje.',
        'queue_time_to_small': 'Čas čakalne vrste je prekratek. Uporabite daljše trajanje.',
        'tax_number_not_found': 'Davčna številka ni bila najdena',
        'tax_number_country_not_specified': 'Država za davčno številko ni navedena',
        'tax_number_invalid_data': 'Za davčno številko so bili prejeti neveljavni podatki'
    },
    'success': {
        'on_add': 'Uspešno dodano',
        'on_edit': 'Uspešno urejeno',
        'on_delete': 'Uspešno izbrisano',
        'on_publish': 'Uspešno objavljeno',
        'on_approve': 'Uspešno potrjeno',
        'on_sort': 'Uspešno razvrščeno',
        'on_change_password': 'Geslo je bilo uspešno spremenjeno',
        'channel_package_activated': 'Paket kanalov je bil uspešno aktiviran',
        'channel_package_deactivated': 'Paket kanalov je bil uspešno deaktiviran'
    },
    'confirmations': {
        'general': 'Ali ste prepričani, da želite nadaljevati?',
        'header': 'Ali ste prepričani',
        'delete_row': 'Ali ste prepričani, da želite izbrisati',
        'deactivate_row': 'Ali ste prepričani, da želite deaktivirati',
        'publish': 'Ali ste prepričani, da želite objaviti na',
        'approve': 'Ali ste prepričani, da želite potrditi'
    },
    'table': {
        'no_data': 'Ni podatkov za prikaz',
        'press_enter_search': 'Pritisnite enter za iskanje',
        'search': 'Iskanje po',
        'select_option': 'Izberi možnost',
        'select_date': 'Izberi datum',
        'select_range': 'Izberi obseg',
        'of': 'od'
    },
    'language': {
        'slovenian': 'Slovenščina',
        'english': 'Angleščina'
    },
    'profile': {
        'profile': 'Profil',
        'edit_profile': 'Uredi profil',
        'old_password': 'Staro geslo',
        'new_password': 'Novo geslo',
        'confirm_password': 'Potrdi geslo',
        'change_password_text': 'Če je polje za geslo prazno, se geslo ne bo spremenilo.',
        'change_password': 'Spremeni geslo'
    },
    'role': {
        'role': 'Vloga | Vloge',
        'admin': 'Administrator',
        'user': 'Uporabnik'
    },
    'user': {
        'user': 'Uporabnik | Uporabniki',
        'add': 'Dodaj uporabnika',
        'edit': 'Uredi uporabnika',
        'name': 'Ime',
        'username': 'Uporabniško ime',
        'image': 'Slika',
        'password': 'Geslo',
        'confirm_password': 'Potrdi geslo',
        'cannot_edit_username': 'Uporabniškega imena ni mogoče urejati',
        'change_password': 'Spremeni geslo',
        'new_password': 'Novo geslo'
    },
    'equipment': {
        'additional_equipment': 'Dodatna oprema | Dodatna oprema',
        'card_payment_equipment': 'Oprema za kartično plačevanje | Oprema za kartično plačevanje',
        'add_additional_equipment': 'Dodaj dodatno opremo',
        'edit_additional_equipment': 'Uredi dodatno opremo',
        'add_card_payment_equipment': 'Dodaj opremo za kartično plačevanje',
        'edit_card_payment_equipment': 'Uredi opremo za kartično plačevanje',
        'color': 'Barva',
        'monthly_price': 'Mesečna cena',
        'one_time_price': 'Enkratna cena',
        'bought': 'Nabavljeno',
        'not_bought': 'Ni nabavljeno',
        'provider_name': 'Ime pri ponudniku'
    },
    'current_program': {
        'current_program': 'Trenutni program | Trenutni programi',
        'add': 'Dodaj trenutni program',
        'edit': 'Uredi trenutni program',
        'color': 'Barva'
    },
    'customer': {
        'customer': 'Stranka | Stranke',
        'add': 'Dodaj stranko',
        'edit': 'Uredi stranko',
        'alias': 'Alias',
        'tax_number': 'Davčna številka',
        'tax_payer': 'Davčni zavezanec',
        'address': 'Naslov',
        'current_program': 'Trenutni program',
        'seller': 'Prodajalec | Prodajalci',
        'date_of_visit_customer': 'Datum obiska stranke',
        'person_who_entering_data': 'Oseba, ki vnaša podatke',
        'date_by_which_data_must_be_entered': 'Datum do katerega morajo biti podatki vneseni',
        'installation_date': 'Datum namestitve',
        'installation_service_technicians': 'Serviserji za namestitev',
        'cash_register_license': 'Licenca za blagajno',
        'number_of_desktop_devices': 'Število namiznih naprav',
        'number_of_mobile_devices': 'Število mobilnih naprav',
        'value_of_offer_to_customer': 'Vrednost ponudbe za stranko',
        'estimated_monthly_price': 'Ocenjena mesečna cena opreme',
        'estimated_one_time_price': 'Ocenjena enkratna cena opreme',
        'contract_value': 'Vrednost pogodbe',
        'difference_between_offer_value_and_contract_value': 'Razlika med vrednostjo ponudbe in vrednostjo pogodbe',
        'message': 'Sporočilo',
        'customers_without_added_users': 'Stranke brez dodanih uporabnikov',
        'move_to_sale': 'Premakni v prodajo',
        'view_customer': 'Obisk stranke',
        'enter_data': 'Vnos podatkov',
        'installation': 'Namestitev',
        'status': {
            'status': 'Status',
            'current_status': 'Trenutni status',
            'change_status': 'Spremeni status',
            'waiting': 'Čakanje',
            'sale': 'Prodaja',
            'entering_data': 'Vnos podatkov',
            'installation': 'Namestitev',
            'completed': 'Zaključeno'
        },
        'graph': {
            'number_of_clients_by_program': 'Število strank po programu',
            'number_of_customers_with_waiting_status': 'Število strank, ki imajo status čakanje',
            'number_of_customers_waiting_for_equipment': 'Število strank, ki čakajo na opremo',
            'number_of_customers_without_assigned_users': 'Število strank brez dodeljenih uporabnikov'
        },
        'price_list': 'Cenik',
        'certificate': 'Certifikat',
        'certificate_password': 'Geslo certifikata',
        'list_of_employees': 'Seznam zaposlenih',
        'contract': 'Pogodba',
        'enter_text': 'Vnesi besedilo'
    },
    'contact': {
        'contact': 'Kontakt',
        'phone_number': 'Telefonska številka'
    },
    'cash_register': {
        'cash_register': 'Blagajna',
        'mobile_cash_register': 'Mobilna blagajna',
        'cash_register_data': 'Podatki o blagajni',
        'essential': 'Essential',
        'standard': 'Standard',
        'premium': 'Premium',
        'reduced_essential': 'Reduced essential',
        'monthly_rental': 'Mesečni najem',
        'calculations': 'Izračuni pogodb',
        'additional': 'Dodatno'
    },
    'besteron': {
        'payment_data': 'Podatki za plačilo Besteron',
        'company_name': 'Ime podjetja',
        'activity': 'Dejavnost',
        'activity_suggestion': '(restavracija, trgovina,...)',
        'pos_terminal_location': 'Lokacija POS terminala',
        'pos_terminal_location_suggestion': 'naslov',
        'location_name': 'Ime lokacije',
        'location_name_suggestion': 'ime trgovine, lokala',
        'contact_person': 'Kontaktna oseba',
        'email': 'E-pošta',
        'email_suggestion': 'bodo prihajali izpiski',
        'phone_number': 'Telefonska številka',
        'tax_number': 'Davčna številka',
        'registration_number': 'Matična števila',
        'iban': 'IBAN',
        'expected_traffic': 'Pričakovan promet',
        'annual_gross_turnover': 'Letni bruto promet',
        'gross_card_turnover': 'Bruto kartični promet',
        'one_time_maximum_payment': 'Enkratno maksimalno plačilo',
        'average_card_payment': 'Povprečno kartično plačilo',
        'minimum_transaction_fee': 'Minimalna transakcijska provizija',
        'number_of_pos_terminals': 'Število pos terminalov',
        'owner_of_space_or_tenats': 'Lastnik prostora / najemnik',
        'owner_of_space': 'Lastnik prostora',
        'space_rental': 'Najem prostora',
        'wifi_or_lte': 'WiFi / LTE',
        'wifi': 'WiFi',
        'lte': 'LTE',
        'purchase_of_terminal_or_rental': 'Nakup terminala / Najem terminala',
        'purchase_of_terminal': 'Nakup terminala',
        'terminal_rental': 'Najem terminala',
        'personal_card_image': 'Slika osebne kartice',
        'name_of_terminal': 'Ime terminala',
        'company_data': 'Podatki o podjetju',
        'turnover': 'Promet',
        'other': 'Ostalo',
        'start_of_billing': 'Pričetek obračuna terminala',
        'accounting_period': 'Obračunsko obdobje',
        'daily': 'Dnevno',
        'weekly': 'Tedensko',
        '14_daily': '14 dnevno',
        'monthly': 'Mesečno',
        'term_terminal': 'Ročnost najema terminala',
        'short_term': 'Kratkoročno',
        'long_term': 'Dolgoročno'
    },
    'equipment_procurement': {
        'equipment_procurement': 'Nabava opreme',
        'edit': 'Uredi nabavo',
        'do_you_really_want_to_cancel_purchased_equipment': 'Ali res želite preklicati nabavljeno opremo'
    },
    'calendar': {
        'calendar': 'Koledar',
        'visit': 'Obisk',
        'entry': 'Vnos',
        'installation': 'Namestitev'
    },
    'business_unit': {
        'business_unit': 'Poslovna enota',
        'unmovable_unit': 'Nepremični poslovni prostor',
        'movable_unit': 'A - Premičen objekt (npr. prevozno sredstvo, premična stojnica)',
        'permanent_location_unit': 'B - Objekt na stalni lokaciji (npr. stojnica na tržnici, kiosk)',
        'device_unit': 'C - Posamezna elektronska naprava za izdajo računov',
        'business_unit_type': 'Tip poslovnega prostora',
        'business_unit_code': 'Šifra poslovnega prostora',
        'address': {
            'address': 'Naslov',
            'street': 'Ulica',
            'house_number': 'Hišna številka',
            'house_number_additional': 'Dodatek',
            'postal_code': 'Poštna številka',
            'city': 'Kraj',
            'cadastral': 'Katastrska občina',
            'cadastral_number': 'Številka katastrske občine',
            'building_number': 'Številka stavbe',
            'building_section_number': 'Številka stavbnega odseka',
            'community': 'Naselje'
        },
        'at_different_address': 'Poslovna enota na drugem naslovu',
        'business_unit_address': 'Naslov poslovne enote',
        'business_unit_postal_code': 'Poštna številka poslovne enote'
    },
    'attachment': {
        'attachment': 'Datoteka | Datoteke',
        'browse_attachment': 'Poišči datoteko'
    }
}
